var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"ef5f872dc334def50a8d74f8e13e415dc16b0723"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs'

import { config } from '~/config'
import { applyGiftSentryEvent } from '~/libs/sentryGift'

Sentry.init({
  dsn: config.sentry.dsn,
  // Replay may only be enabled for the client-side
  integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
  environment: config.foodEnv,
  // captureGiftIssue が付けたイベントだけ fingerprint を付け、30 秒でまとめる。
  // それ以外のイベントと traces / replay の率は変えない。
  beforeSend: applyGiftSentryEvent,

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.05,

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.0001,
  replaysOnErrorSampleRate: 0.05,

  // ...

  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
})
